import * as Fetch from '@/helpers/fetch'

export const registerCampaign = async (
  token: string,
  campaignId: string,
): Promise<Fetch.HttpResponse> => {
  const url = `${process.env.VUE_APP_CAMPAIGN_BFF_URL}/v1/customers/me/tags`
  const body = {
    campaign_id: campaignId
  }

  const options = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
      'channel': 'line'
    },
    body: JSON.stringify(body),
  }
  try {
    const result = await Fetch.post(url, options)
    return result
  } catch (error) {
    throw new Error('พบข้อผิดพลาดบางประการ กรุณาลองใหม่อีกครั้ง')
  }
}
